// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../../actions/venues';

const createSagas = (API: Object): Object => {
	function* fetchVenues() {
		try {
			const result = yield call(API.venues.fetch);
			yield put(actions.fetchVenuesSuccess(result));
		}
		catch (e) {
			if (process.env.NODE_ENV !== 'test') {
				console.error(e);
			}
			yield put(actions.fetchVenuesFailed(e.message));
		}
	}

	function* watch() {
		yield takeLatest(actions.fetchVenues, fetchVenues);
	}

	return {
		fetchVenues,
		watch,
	};
};


export default createSagas;


// WEBPACK FOOTER //
// ./src/modules/sagas/venues/index.js